import styled from 'styled-components';
const getMargin = ({
  'data-context-help': contextHelp,
  'data-left-margin': leftMargin = '0.75rem'
}) => {
  const topRightBottomMargin = contextHelp ? '0.375rem 0.75rem 0 ' : '0.375rem 0 0 ';
  return topRightBottomMargin + leftMargin;
};
export default styled.div`
  font-size: ${({
  theme
}) => theme.typography.sizes.text.desktop.xs.fontSize};
  font-weight: 400;
  line-height: 1rem;
  margin: ${getMargin};
  text-align: ${props => props.$align || 'left'};

  &[data-error='true'] {
    color: ${({
  theme
}) => theme.palette.semanticError};
  }

  &[data-context-help='true'] {
    font-size: ${({
  theme
}) => theme.typography.sizes.text.desktop.sm.fontSize};
  }
`;
//# sourceMappingURL=styles.js.map